// extracted by mini-css-extract-plugin
export default {"alert":"style_alert__an57l","popover":"style_popover__z3M5w","popConfirm":"style_popConfirm__2LlwH","buttonWrapper":"style_buttonWrapper__hnIZK"};